export default "__VITE_ASSET__DVXaT31j__"